import './BeWizrCourseItemSearchResult'
import './BeWizrCourseSearchResult'
import './BeWizrLibraryItemSearchResult'
import './BeWizrLibraryTopicSearchResult'
import './MenuPageItemSearchResult'
import './ParticipantSearchResult'
import './PostSearchResult'
// @index(!registry): import ${relpath}
import React from 'react'
import { getSearchResultComponent } from './registry'

// /index

export function renderSearchResult(resource: string, item: any) {
  const Component = getSearchResultComponent(resource)
  if (Component == null) {
    console.warn(`Cannot find search result component for resource "${resource}"`)
    return null
  }

  return React.createElement(Component, {item})
}